import React from "react";
import BlogInner from "../../../bloginner";
import img from "../../../../images/blogphotos/The Magic of Memory Foam.jpg";

export default function MagicOfMemoryFoam({ location }) {
  const data = {
    blogImg: img,

    blogTitle: "The Magic of Memory Foam",

    date: "September 28, 2019",

    content: `<p>Memory Foam, the name itself sounds magical as in “what does it exactly represents”. Is the foam a living thing which will remember what your stress points are? Or is it going to take the exact shape of your body when you lie in it? Or is it going to regulate the body heat for a delightful sleep? The answer is all of the above.</p>

    <p>Yes! You read it right. Memory foam is a revolutionary material, first created for NASA in 1966 to cushion our astronauts right and deflect most of the g-force while taking off and landing. It was developed as a contribution towards the betterment of humanity and we must say it really helped. After realizing its potential in medicine and consumer fields, it was sold to a private company in the 1990s that finally introduced <a href="/memory-foam/"><strong>memory foam mattresses.</strong></a></p>
    
    <p>Today, its benefits have taken up the industry by storm. <a href="/memory-foam/"><strong>Memory foam mattresses</strong></a> and other products account for 20% sales in the bedding industry. It is much more advanced in comfort and costs much lower in comparison to <a href="/spring-mattress/"><strong>spring mattresses</strong></a>. The magic of memory foam not only helped our astronauts on difficult missions, but it is also helping people to have their coveted 8-hour deep sleep. Here are a few magical effects of memory foam:</p>
    
    <p><strong>Stress Relief:</strong/</p>
    
    <p>Memory works on your pressure points to provide relief from pain and stress. It maintains body posture and alignment towards a healthier sleep. It can accommodate different postures and remember your body shape to ensure healthy sleep.</p>
    
    <p><strong>Anti-Allergic:</strong>
    
    <p>Modern-day mattresses suffer a lot from dust build up. A lot of people are allergic to different kinds of mites and can have cough, watery eyes or other symptoms. Memory foam assures that no such dust reaches the mattress as it leaves no such space unlike spring mattresses.</p>
    
    <p><strong>Temperature Sensitive:</strong></p>
    
    <p>As mentioned before, memory foam mattresses are smart and they can regulate body heat to ensure sound sleep. They are at times mixed with cool gel technology to keep the temperature down from 2 to 3 degrees.</p>
    
    <p><strong>Durability:</strong></p>
    
    <p>On an average, memory foam mattresses has a life cycle of 7 years. It is a durable material due to its scientific origins. It can take much adversity without being damaged extensively.</p>
    
    <p>There is no 5th pointer you can ask for. The magic of memory foam is widely accepted and we here at Eclipse, we have perfected the Visco series to bring you the best. For more information visit our home page.</p>`,
    seoDescription:
      "Sleeping on the memory foam mattress has many benefits on both mental and physical health. it improves your sleeping habits and also body posture.",
    seoImg:
      "https://eclipsemattress.in/assets/linkpreviews/blog/The-Magic-of-Memory-Foam.jpg",
  };

  return (
    <div>
      <BlogInner location={location} data={data} />
    </div>
  );
}
